import { gql } from '@urql/core';

import { globalFeatureKeys } from '/src/features/_global/queries';
import { billingFeatureKeys } from './queries';
import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';

export function refreshBillingPlanQueries(queryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ ...globalFeatureKeys.me }),
    queryClient.invalidateQueries({ ...globalFeatureKeys.capabilities }),
    queryClient.invalidateQueries({ ...globalFeatureKeys.subscription }),
    queryClient.invalidateQueries({ ...billingFeatureKeys.pricingGrid }),
  ]);
}

export const createCustomCheckoutSessionMutation = ({ client }) => ({
  mutationFn: ({ planPriceId, recordingsQuantity }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation CreateCustomCheckoutSession($planPriceId: String!, $recordingsQuantity: Int) {
          createCustomCheckoutSession(planPriceId: $planPriceId, recordingsQuantity: $recordingsQuantity) {
            checkoutUrl
          }
        }
      `,
      { planPriceId, recordingsQuantity },
    ),
});

export const updateSubscriptionItemsMutation = ({ client, queryClient }) => ({
  mutationFn: ({ planPriceId, recordingsQuantity }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation UpdateSubscriptionItems($planPriceId: String!, $recordingsQuantity: Int) {
          updateSubscriptionItems(planPriceId: $planPriceId, recordingsQuantity: $recordingsQuantity) {
            url
          }
        }
      `,
      { planPriceId, recordingsQuantity },
    ),
  onSuccess: async () => refreshBillingPlanQueries(queryClient),
});
